
export default class formatDate{
    public static formattedDate(date: Date) {
        const options: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true // Use 12-hour format
        };

        // Convert the date to a locale string
        const formattedDate = date.toLocaleString('en-GB', options);

        // Replace the comma and format to dd/MM/yyyy hh:mm:ss AM/PM
        const [datePart, timePart] = formattedDate.split(', ');
        const [day, month, year] = datePart.split('/');
        const formatted = `${day}/${month}/${year} ${timePart.toUpperCase()}`;

        return formatted;
    }
}